<template>
  <el-card :loading="loading" :body-style="{ padding: '20px 24px 8px' }" :bordered="false">
    <div class="chart-card-header">
      <div class="meta">
        <span class="chart-card-title">
          <slot name="title">
            {{ title }}
          </slot>
          <span v-if="flag" :class="[getFlag]">
            <i :class="'el-icon-caret-' + getFlag" />
          </span>
          <span v-if="linkUrl" style="font-size: 20px;cursor: pointer" class="target_link" @click="handleLink"><i class="el-icon-link" /></span>
        </span>
        <span class="chart-card-action">
          <slot name="action" />
        </span>
      </div>
      <div class="total">
        <slot name="total">
          <span>{{ typeof total === 'function' && total() || total }}</span>
        </slot>
      </div>
    </div>
    <div class="chart-card-content">
      <div class="content-fix">
        <slot name="content" />
      </div>
    </div>
    <div class="chart-card-footer">
      <div class="field">
        <slot name="footer" />
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'ChartCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    flag: {
      type: Boolean,
      default: true
    },
    total: {
      type: [Function, Number, String],
      required: false,
      default: null
    },
    total2: {
      type: Number,
      required: false,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    contrast: {
      type: Boolean,
      default: false,
      required: false
    },
    linkUrl: {
      Type: String,
      default: ''
    }
  },
  computed: {
    getFlag() {
      if (this.contrast) {
        return 'top'
      }
      return 'bottom'
    }

  },
  methods: {
    handleLink() {
      if (this.linkUrl) {
        const arr = this.linkUrl.split('#')
        let url = this.$router.resolve({ name: arr[0] }).href
        if (arr.length > 1) {
          url += '#' + arr[1]
        }
        if (this.linkUrl === 'Order') {
          url += '?gtype=8'
          window.open(url, '_blank')
        } else {
          window.open(url, '_blank')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .chart-card-header {
    position: relative;
    overflow: hidden;
    width: 100%;
    .meta {
      position: relative;
      overflow: hidden;
      width: 100%;
      color: rgba(0, 0, 0, .45);
      font-size: 14px;
      line-height: 22px;
    }
  }
  .chart-card-action {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
  }
  .chart-card-footer {
    border-top: 1px solid #e8e8e8;
    padding-top: 9px;
    margin-top: 8px;
    > * {
      position: relative;
    }
    .field {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0;
      color: rgba(0,0,0,.65);
      font-size: 14px;
    }
  }
  .chart-card-content {
    margin-bottom: 12px;
    position: relative;
    height: 23px;
    width: 100%;
    .content-fix {
      font-size: 14px;
      position: absolute;
      top: 1px;
      bottom: 0;
      width: 100%;
    }
  }
  .total {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
    color: #000;
    margin-top: 4px;
    margin-bottom: 0;
    font-size: 30px;
    line-height: 38px;
    height: 38px;
  }
  .top,
  .bottom {
    margin-left: 4px;
    position: relative;
    top: 1px;
    width: 15px;
    display: inline-block;
    i {
      font-size: 18px;
      transform: scale(0.83);
    }
  }

  .top {
    i{
      color: #f5222d!important;
    }
  }
  .bottom {
    top: -1px;
    i{
      color: #52c41a!important;
    }
  }
  .target_link{
    float: right;
  }
</style>
